export default __webpack_public_path__ + "static/media/sep2023-1.c3c0c4fd.jpg";